import { Switch } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import {
  CommaLists,
  GetResearchBrandPresenceApiArg,
  useExportBrandPresence,
} from '../../../../app/api'
import { setSerpPresence } from '../../model/serpPresenceSlice'
import { AiButton } from '../../../../shared/components/ai/ai-button/AiButton'
import { useAiChat } from '../../../../shared/components/ai/ai-provider/AiProvider'
import { ExportDrop } from '../../../../shared/components/cards/export-drop/ExportDrop'

import styles from './SerpPresenceActions.module.scss'

export interface ISerpPresenceActionsProps {
  /** Текущий запрос таблицы: с ним же уходит выгрузка */
  queryParams?: Partial<CommaLists<GetResearchBrandPresenceApiArg>>
}

export const SerpPresenceActions = ({ queryParams }: ISerpPresenceActionsProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleSendMessage } = useAiChat()
  const [exportBrandPresence, { isFetching: exportLoading }] = useExportBrandPresence()

  return (
    <div className={styles.root}>
      {
        {
          bluepear: (
            <AiButton
              unstyled
              onClick={() =>
                handleSendMessage({
                  message:
                    'Please provide a clear guide on how to use the On-Site Brand Mentions Dashboard and explain its value.',
                })
              }
            >
              How the report works
            </AiButton>
          ),
          robuscan: null,
          default: null,
        }[process.env.REACT_APP_PROJECT ?? 'default']
      }
      <span className={styles.noSerpWrap}>
        {t('fields.noSERPPresence')}
        <Switch
          checked={queryParams?.noSerpPresence}
          onClick={() => dispatch(setSerpPresence(!queryParams?.noSerpPresence))}
        />
      </span>
      <span className={styles.exportWrap}>
        <ExportDrop
          columns={[
            { keys: ['keyword'], label: t('table.columns.keyword') },
            { keys: ['paid_count'], label: t('table.columns.paidResults') },
            { keys: ['organic_count'], label: t('table.columns.organicResults') },
            { keys: ['first_updated'], label: t('table.columns.firstUpdated') },
            { keys: ['last_updated'], label: t('table.columns.lastUpdated') },
          ]}
          loading={exportLoading}
          onExport={(exportParams) => exportBrandPresence({ ...queryParams, ...exportParams })}
        />
      </span>
    </div>
  )
}
